module.exports = __webpack_public_path__ + "img/door-closed-fill.c176a9a3.svg";